// src/mobile/MobileHero.js
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

// Importa todas las imágenes
import heritageBackground from "../assets/images/HeritageBackground.png";
import jets from "../assets/images/Jets.jpg";
import lincolnTransfer from "../assets/images/lincoln_transfer.png";
import sprinterService from "../assets/images/sprinter_service.png";
import escaladeService from "../assets/images/escalade_service.png";
import Escalade1 from "../assets/images/Escalade1.jpg";
import HeritageCarAirport from "../assets/images/HeritageCarAirport.jpg";
import HeritageMKT from "../assets/images/HeritageMKT.jpg";
import MKT1 from "../assets/images/MKT1.jpg";

const MobileHero = () => {
  // Estado para activar el carrusel tras mostrar la imagen estática
  const [isCarouselActive, setIsCarouselActive] = useState(false);
  // Índice actual del carrusel
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array de imágenes para el carrusel (todas las imágenes importadas)
  const carouselImages = [
    heritageBackground,
    jets,
    lincolnTransfer,
    sprinterService,
    escaladeService,
    Escalade1,
    HeritageCarAirport,
    HeritageMKT,
    MKT1,
  ];

  // Muestra la imagen estática durante 3 segundos y luego activa el carrusel
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsCarouselActive(true);
      setCurrentIndex(0);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  // Cuando el carrusel esté activo, cambia la imagen cada 4 segundos
  useEffect(() => {
    let interval;
    if (isCarouselActive) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
      }, 4000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isCarouselActive, carouselImages.length]);

  // Selecciona la imagen de fondo
  const backgroundImage = isCarouselActive
    ? carouselImages[currentIndex]
    : carouselImages[0];

  return (
    <>
      <Helmet>
        <title>Heritage Car Airport - Premium Taxi & Transfer Services</title>
        <meta
          name="description"
          content="Heritage Car Airport offers luxurious and reliable taxi services for airport transfers and local trips. Discover our dynamic hero section."
        />
        <meta name="robots" content="index,follow" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Heritage Car Airport - Premium Taxi & Transfer Services"
        />
        <meta
          property="og:description"
          content="Heritage Car Airport provides premium taxi rides with efficiency and elegance."
        />
        <meta property="og:url" content="https://heritagecarairport.com/hero" />
        <meta
          property="og:image"
          content="https://heritagecarairport.com/images/your-og-image.jpg"
        />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Heritage Car Airport - Premium Taxi & Transfer Services"
        />
        <meta
          name="twitter:description"
          content="Heritage Car Airport offers luxurious taxi rides available 24/7."
        />
        <meta
          name="twitter:image"
          content="https://heritagecarairport.com/images/your-og-image.jpg"
        />

        {/* JSON-LD para LocalBusiness */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Heritage Car Airport",
            "image": "https://heritagecarairport.com/images/logo.jpg",
            "foundingDate": "2005",
            "identifier": "DOS ID #7502116",
            "@id": "https://heritagecarairport.com/",
            "url": "https://heritagecarairport.com/",
            "telephone": "+1-914-276-2961",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "395 Hallocks Mill Rd",
              "addressLocality": "Yorktown Heights",
              "addressRegion": "NY",
              "postalCode": "10598",
              "addressCountry": "US"
            },
            "description": "Heritage Car Airport provides premium taxi services for efficient airport transfers and local trips with luxury and reliability.",
            "sameAs": [
              "https://www.facebook.com/yourpage",
              "https://www.instagram.com/yourprofile"
            ]
          })}
        </script>
      </Helmet>

      {/* Sección Hero con imagen de fondo */}
      <section
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "300px",
          width: "100%",
          marginTop: "80px",
          transition: "background-image 1s ease-in-out",
        }}
      >
        {/* La sección se muestra sin overlay para que las imágenes se vean limpias */}
      </section>
    </>
  );
};

export default MobileHero;
